import { useMutation } from "@tanstack/react-query";
import type { User } from "@models/User";
import useStorage from "@utils/UseStorage";
import { apiPatch } from "../client";

/**
 * Hook to get the currently logged-in user from localStorage
 */
export function useLoggedInUser() {
	const { getItem } = useStorage();

	const user = getItem("user") ? JSON.parse(getItem("user")) : undefined;

	return user as User;
}

/**
 * Hook to update user password
 */
export function useUpdateUserPassword(onSuccess?: () => any, onError?: (errorCode: string) => void) {
	return useMutation({
		mutationFn: async (data: { currentPassword: string; newPassword: string }) => {
			return apiPatch("/fruster-user", {
				currentPassword: data.currentPassword,
				password: data.newPassword,
			});
		},
		onSuccess,
		onError: (error: any) => {
			const errorCode = error?.response?.data?.code || error?.message || "UNKNOWN_ERROR";
			if (onError) {
				onError(errorCode);
			}
		},
	});
}
